/*require('./../../../style/input-plugin/shortcut.less');*/
var $ = require('jQuery');
var template = require('./../../../template/input-plugin/shortcut.html');
var Plugin = require('./Plugin');
var config = require('../../../global/config');
//var stat = require('./../../../global/stat');
//var StatPoint = require('./../../../constant/StatPoint');

var Shortcut = function (options) {
    this._opened = false;

    (function (self) {
        var defaults = {
            template: template,
            texts: [
                // '能见面交易？',
                // '亲，包邮吗？',
                // '价格还可以商量？',
                // '你好，这个职位还在招人吗？',
                // '你好，这套房源租出去了吗？'
            ]
        };
        $.extend(defaults, options);
        Plugin.call(self, defaults);
        var eleTextList = self._element.find('.im-shortcut-texts');
        self._element.find('.im-shortcut-icon').click(function () {
            if (self._opened) {
              self.close();
            } else {
              self.open();
            }
            self.triggerEvent('setBussinessSession');
            //埋点统计（快捷消息按钮点击）
            //stat.report(StatPoint.shortcut_btn_click);
            if(window.WMDA_REPORT){
              window.WMDA_REPORT('custom',{event_id:'15'})
            }
            // 已经加载业务会话
            if (eleTextList[0].getElementsByTagName('li') && eleTextList[0].getElementsByTagName('li').length > 0) {
              return;
            } else {
              config['msg-shortcut'].forEach(item => {
                $('<li>').text(item).appendTo(eleTextList);
              });
            }
            
        });

        // var eleTextList = self._element.find('.im-shortcut-texts');
        // $(defaults.texts).each(function (index, item) {
        //     $('<li>').text(item).appendTo(eleTextList);
        // });
        eleTextList.click(function (e) {
            self.close();
            if (e.target.tagName == 'LI') {
                self._input.send({
                    type: 'text',
                    msg: $(e.target).html()
                });
            }
        });

        $(self._win).click(function (e) {
            if (self._opened && !$.contains(self._element[0], e.target))
                self.close();
        });
    })(this);
};
Shortcut.prototype = Object.create(Plugin.prototype);

module.exports = Shortcut;
